module.exports = {"620201100":"新城镇","620201101":"峪泉镇","620201102":"文殊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620201.json
// module id = 2687
// module chunks = 0